$(document).ready(function () {
	// Header-new & Nav + responsive
	$('.desktop-nav li').click(function () {
		$(this).addClass('active')
		$(this).parent().children('li').not(this).removeClass('active')
	})

	$('.mobile-nav-icon').click(function () {
		$('.header-new__mob-nav__holder').css('display', 'flex')
	})

	$('.header-new__mobile-close').click(function () {
		$('.header-new__mob-nav__holder').hide()
	})

	$('.header-new__mobile-logo a').click(function () {
		$('.header-new__mob-nav__holder').hide()
	})

	$('.header-new__mob-nav__holder li').click(function () {
		$('.header-new__mob-nav__holder').hide()
	})

	// Fancybox global init
	Fancybox.bind('[data-fancybox]')
})

function toggleFbLoginDrop(event) {
	event.stopPropagation()
	var isOpen = $('.fb-login__drop').toggleClass('show').hasClass('show')
	$('.fb-login__drop').attr('aria-hidden', !isOpen)
	$('#fbLoginBtn').attr('aria-expanded', isOpen)
	$('#fbMobLoginBackdrop').toggleClass('open')
}

$(document).on('click', function () {
	$('.fb-login__drop').removeClass('show').attr('aria-hidden', true)
	$('#fbLoginBtn').attr('aria-expanded', false)
	$('#fbMobLoginBackdrop').removeClass('open')
})

function fbOpenMobMenu() {
	$('#fbMobMenu').toggleClass('open')
}

function fbCloseMobMenu() {
	$('#fbMobMenu').removeClass('open')
}

function fbConfirmLogout() {
	$('#fbUbModal').addClass('open')
}

function fbCloseLogoutModal() {
	$('#fbUbModal').removeClass('open')
}

function fbDoLogout() {
	$('#fbUbModal').removeClass('open')
	$('.fb-login__guest').prop('hidden', false)
	$('#headerClaim').removeClass('hide')
	$('.fb-header__ikona').removeClass('show')
	$('#fbLoginUser').prop('hidden', true)
	$('#fbToastContainer2').addClass('show')
	setTimeout(function () {
		$('#fbToastContainer2').removeClass('show')
	}, 3000)
}

function fbDoLogin() {
	$('.fb-login__guest').prop('hidden', true)
	$('#fbLoginUser').prop('hidden', false)
	$('#headerClaim').addClass('hide')
	$('.fb-header__ikona').addClass('show')
	$('#fbToastContainer').addClass('show')
	setTimeout(function () {
		$('#fbToastContainer').removeClass('show')
	}, 3000)
}

function fbDoLoginFirma() {
	$('#fbToastContainer3').addClass('show')
	setTimeout(function () {
		$('#fbToastContainer3').removeClass('show')
	}, 3000)
}

var fpEmailPhase = 'idle'

function fpEmailStart(event) {
	event.stopPropagation()
	fpEmailPhase = 'email'
	$('#fpEmailInput').val('').attr('placeholder', 'Zadejte svůj e-mail').attr('type', 'email')
	$('#fpEmailStep .fp-login__odeslat').text('Odeslat kód')
	$('#fpEmailStep').prop('hidden', false)
	$('#fpEmailInput').focus()
}

function fpEmailSubmit(event) {
	event.preventDefault()
	if (fpEmailPhase === 'email') {
		var email = $('#fpEmailInput').val()
		$('#fbToastEmail').text(email)
		$('#fbToastContainer4').addClass('show')
		setTimeout(function () {
			$('#fbToastContainer4').removeClass('show')
		}, 3000)
		$('#fpEmailInput').val('').attr('placeholder', 'Zadejte kód z e-mailu').attr('type', 'text')
		$('#fpEmailStep .fp-login__odeslat').text('Přihlásit')
		fpEmailPhase = 'code'
	} else if (fpEmailPhase === 'code') {
		fpEmailPhase = 'idle'
		$('#fpEmailStep').prop('hidden', true)
		$('.fb-login__drop').removeClass('show').attr('aria-hidden', true)
		$('#fbLoginBtn').attr('aria-expanded', false)
		$('#fbMobLoginBackdrop').removeClass('open')
		fbDoLogin()
	}
}
